import Vue from 'vue';
import {
  BVConfigPlugin,
  CollapsePlugin,
  DropdownPlugin,
  ModalPlugin,
  ProgressPlugin,
  TabsPlugin,
  TooltipPlugin,
  ToastPlugin
} from 'bootstrap-vue';

Vue.use(BVConfigPlugin, {
  BToast: {
    noCloseButton: true,
    autoHideDelay: 5000,
    appendToast: true,
    toaster: 'b-toaster-bottom-center',
    solid: true,
  },
});

Vue.use(ModalPlugin);
Vue.use(TabsPlugin);
Vue.use(CollapsePlugin);
Vue.use(DropdownPlugin);
Vue.use(TooltipPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
